export enum SafetyEquipmentType {
  Owned = 'OWNED',
  Borrowed = 'BORROWED',
  BorrowedReturnable = 'BORROWED_RETURNABLE',
}
